import { z } from 'zod'

export const deleteResponseSchema = z.object({
  deleted: z.number().int().nonnegative(),
})

export type DeleteResponse = z.infer<typeof deleteResponseSchema>
